<template>
  <div class="bg-dim flex-col">
    <div class="safe-area absolute">
      <div class="close-popup">
        <button type="button" @click="showTomorrow">오늘 하루 보지 않기<img src="@/assets/images/ico-close.svg" alt="닫기" /></button>
      </div>
      <div class="popup-wrap">
        <div>
          <div>
            <img src="@/assets/images/pw-guard.svg" alt="" />
          </div>
          <p v-html="confirmTitle" />
          <span v-html="confirmText" />
        </div>
      </div>
      <div class="button-wrap">
        <button class="button-bg-gray border-left-round" @click="noEvent()">닫기</button>
        <button class="button-bg-yellow border-right-round" @click="yesEvent()">비밀번호 설정</button>
      </div>
    </div>
  </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
export default {
  name: 'guidancePeriodPopup',
  props: ['confirmTitle', 'confirmText'],
  components: { BottomButton },
  data() {
    return {};
  },
  methods: {
    noEvent() {
      //아니오 버튼 눌렀을때 이벤트
      this.$emit('confirmPopupClickNo', 'no');
    },
    yesEvent() {
      //예 버튼 눌렀을때 이벤트
      this.$emit('confirmPopupClickYes', 'yes');
    },
    showTomorrow() {
      // 오늘 하루 보지 않기 버튼 클릭 시 이벤트
      this.$emit('confirmPopupClickTomorrow', 'yes');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/pages/cards/pwSetupPopup.scss';
</style>
